export function printPrice(price) {
    if (!price) {
        return "0.00";
    }

    return price.toFixed(2);
}

export function printPriceFourDigits(price) {
    if (!price) {
        return "0.00";
    }

    return price.toFixed(4);
}

export const roundToTwoDecimal = value => {
    if (value === 0) {
        return 0;
    }
    return Math.ceil(value * 100) / 100;
};

export const roundToFourDecimal = value => {
    if (value === 0) {
        return 0;
    }
    return Math.round(value * 10000) / 10000;
};
